/*
 * Full-screen branded loading indicator. Used by:
 *
 *  - root.tsx's HydrateFallback (during initial JS bundle download — see
 *    LoadingScreen.css for how the styles are inlined into the prerendered
 *    HTML so it renders before Tailwind has loaded).
 *  - _app/route.tsx while the user/features queries are settling after
 *    hydration.
 *
 * The wrapping element is <main> so role-based locators (e.g. Playwright
 * `getByRole('main')`) match while the real route content isn't on screen
 * yet — same role the default RR fallback uses.
 */
export function LoadingScreen() {
  return (
    <main className="initial-loader">
      <div aria-hidden="true" className="initial-loader__spinner" />
      <div className="initial-loader__text">Fat Bees</div>
    </main>
  );
}
